import React from 'react';
import { useNavigate } from 'react-router-dom';
import { OnboardingData } from '../../..';
import { StockLocation } from '../../../../../../types/stock_location/stockLocation';
import { countries } from '../../../../../../util/country';

interface OnboardingStockLocationItemProps {
  stockLocation: StockLocation;
  data: OnboardingData;
  setData: (data: OnboardingData) => void;
}

export default function OnboardingStockLocationItem({
  stockLocation,
  data,
  setData,
}: OnboardingStockLocationItemProps) {
  const navigate = useNavigate();

  return (
    <div className='grid gap-2 bg-gray-100 px-6 py-4'>
      <p className='text-sm font-medium text-gray-900'>{stockLocation.name}</p>

      {stockLocation.address && (
        <div className='text-sm text-gray-600'>
          {stockLocation.address?.addressLine1 && <p>{stockLocation.address.addressLine1}</p>}
          {stockLocation.address?.postalCode || stockLocation.address?.city ? (
            <span>
              {stockLocation.address?.postalCode + ' ' || ''}
              {stockLocation.address?.city || ''}
            </span>
          ) : null}
          {stockLocation.address?.countryCode && (
            <p>{countries.find(c => c.cca2 === stockLocation.address?.countryCode)?.name.common}</p>
          )}
        </div>
      )}
    </div>
  );
}
